import React from 'react';
import proptypes from 'prop-types';
import Slide from './slide';

const LeaseSlider = ({ slides, id }) => (
  <div
    className="lease-slider slider-pro"
    id={id}
    data-slider-width="100%"
    data-slider-arrows="false"
    data-slider-buttons="false"
  >
    <div className="sp-slides">
      <Slide slides={slides} />
    </div>
  </div>
);

export default LeaseSlider;

LeaseSlider.propTypes = {
  id: proptypes.string.isRequired,
  slides: proptypes.arrayOf(
    proptypes.shape({
      title: proptypes.string,
      url: proptypes.string,
    })
  ).isRequired,
};
